import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Alert, AlertIcon, AlertTitle, AlertDescription, Button, Stack, Text } from '@chakra-ui/react';
import { getApiUrl } from '../../../utilities/envVariables';
import { useNavigate } from 'react-router-dom';
import LoginWrapper from '../../molecules/LoginWrapper';
import { titleAppend } from '../../../utilities/head';

export default function StatusEmail() {
  const [result, setResult] = useState<boolean | undefined>();
  const navigate = useNavigate();

  const isVisaUpdate = window.location.pathname.includes('/visaStatusUpdate');
  const isNoChange = window.location.pathname.includes('/noChangeArrival');

  const params = window.location.pathname.split('/');
  const url = params[params.length - 1];

  const queryString = window.location.search;
  const searchParams = new URLSearchParams(queryString);
  const hash = searchParams.get('hash');

  useEffect(() => {
    async function updateStatus() {
      if (isNoChange) {
        setResult(true);
      } else if (!hash) {
        setResult(false);
      } else {
        try {
          const fullUrl = new URL(`${url}${window.location.search}`, getApiUrl())
          const resp = await fetch(fullUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Cas-Shield-Site': window.location.origin
            }
          });
          if (resp.ok) {
            setResult(true);
          } else {
            setResult(false);
          }
        } catch (e) {
          setResult(false);
        }
      }
    }
    updateStatus();
  }, [isNoChange, getApiUrl, hash]);

  const LoadingContent = (
    <Alert status="loading">
      <AlertIcon />
      Please wait ...
    </Alert>
  );

  const SuccessContent = (
    <Alert status="success">
      <AlertIcon />

      <Box>
        <AlertTitle>Thank you for keeping us updated</AlertTitle>

        <AlertDescription>
          <Text>
            By providing these quick updates {isVisaUpdate ? 'on your visa application' : ''}
            you are allowing us to prepare for your arrival.
          </Text>

          <Text mb={0}>You can close this browser window.</Text>
        </AlertDescription>
      </Box>
    </Alert>
  );

  const FailureContent = (
    <Alert status="error">
      <AlertIcon />

      <Box>
        <AlertTitle>Sorry, there was a problem</AlertTitle>

        <AlertDescription>
          <Text>Your update was not submitted due to an error. Please return to your email and try again.</Text>

          <Text mb={0}>You can close this browser window.</Text>
        </AlertDescription>
      </Box>
    </Alert>
  );

  return (
    <LoginWrapper isLoading={false} apiCallsInProgress={[]} heading="Status update">
      <Helmet>
        <title>Status Update {titleAppend}</title>
      </Helmet>

      {result === undefined ? LoadingContent : result === true ? SuccessContent : FailureContent}

      <Stack mt={8} spacing="3">
        <Button size="lg" variant="solid" onClick={() => navigate('/')}>
          Log in
        </Button>
      </Stack>
    </LoginWrapper>
  );
}
